import { Typography, message, Input, Button, Row, Col, Space, Modal, Card } from "antd";
import { PlusOutlined, DeleteOutlined, CopyOutlined } from "@ant-design/icons";
import { useState, useEffect } from "react";
import VerificationsIndex from "./VerificationsIndex";
import AddVerificationForm from "./forms/general/AddVerificationForm";
import axios from "axios";
import { useAuth } from "../../layout/auth";
import PageTitle from "../../utils/PageTitle";
import PageWrapper from "../../utils/PageWrapper";
import { ClipboardCheck } from "lucide-react";

const { Title } = Typography;

export default function Verifications() {
  const [selectedVerification, setSelectedVerification] = useState(null);
  const [verifications, setVerifications] = useState();
  const [search, setSearch] = useState();
  const [filteredVerifications, setFilteredVerifications] = useState();
  const [loading, setLoading] = useState(false);
  const [agregarVerificacionVisible, setAgregarVerificacionVisible] = useState(false);
  const [clonarVerificacionVisible, setClonarVerificacionVisible] = useState(false);
  const [eliminarVerificacionVisible, setEliminarVerificacionVisible] = useState(false);

  const auth = useAuth();

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/verificaciones`, {
        params: { u: auth.UID },
      })
      .then((res) => {
        setVerifications(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        message.error(err.message);
      });
  }, [auth.UID]);

  useEffect(() => {
    if (search) {
      const filtered = verifications.filter((verification) => {
        return (
          verification?.ControlInterno?.toString().toLowerCase().includes(search.toLowerCase()) ||
          verification?.DescripcionBreve?.toString().toLowerCase().includes(search.toLowerCase()) ||
          verification?.NombreCliente?.toString().toLowerCase().includes(search.toLowerCase()) ||
          verification?.NombreCompleto?.toString().toLowerCase().includes(search.toLowerCase()) ||
          verification?.ClasificacionSCIAN?.toString().toLowerCase().includes(search.toLowerCase())
        );
      });
      setFilteredVerifications(filtered);
    } else {
      setFilteredVerifications(verifications);
    }
  }, [search, verifications]);

  return (
    <div style={{ minHeight: "100vh" }}>
      <PageWrapper className="verifications-main-card">
        <PageTitle icon={<ClipboardCheck />} title="Verificaciones" />

        {/* Controls Section */}
        <div
          style={{
            padding: "16px",
            background: "rgba(249, 250, 251, 0.8)",
            borderRadius: "12px",
            border: "1px solid rgba(229, 231, 235, 0.6)",
            boxShadow: "0 4px 16px rgba(0, 0, 0, 0.05)",
            marginBottom: "24px",
          }}
        >
          <Row gutter={[16, 16]} align="middle">
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Input.Search
                placeholder="Buscar verificaciones..."
                onSearch={(value) => {
                  setSearch(value);
                }}
                enterButton="Buscar"
                loading={loading}
                size="large"
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ textAlign: "right" }}>
              <Space>
                {auth.Rol !== "administrador" && (
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    size="large"
                    onClick={() => {
                      setAgregarVerificacionVisible(true);
                    }}
                    style={{
                      borderRadius: "8px",
                      height: "40px",
                    }}
                  >
                    Agregar
                  </Button>
                )}
                {auth.Rol !== "administrador" && (
                  <Button
                    type="primary"
                    icon={<CopyOutlined />}
                    size="large"
                    onClick={() => {
                      if (selectedVerification) {
                        setClonarVerificacionVisible(true);
                      } else {
                        message.error("Seleccione una verificación para clonar");
                      }
                    }}
                    style={{
                      borderRadius: "8px",
                      height: "40px",
                      background: "#722ed1",
                      borderColor: "#722ed1",
                    }}
                  >
                    Clonar
                  </Button>
                )}
                {(auth.Rol === "director" || auth.Rol === "admin") && (
                  <Button
                    type="danger"
                    icon={<DeleteOutlined />}
                    size="large"
                    onClick={() => {
                      if (auth.Rol !== "director" && auth.Rol !== "admin") {
                        message.error("No tiene permisos para eliminar verificaciones");
                      } else if (selectedVerification) {
                        setEliminarVerificacionVisible(true);
                      } else {
                        message.error("Seleccione una verificación para eliminar");
                      }
                    }}
                    style={{
                      borderRadius: "8px",
                      height: "40px",
                    }}
                  >
                    Eliminar
                  </Button>
                )}
              </Space>
            </Col>
          </Row>
        </div>

        <VerificationsIndex
          verifications={search ? filteredVerifications : verifications}
          loading={loading}
          setSelectedVerification={setSelectedVerification}
          userRole={auth.Rol}
        />

        <AddVerificationForm
          visible={agregarVerificacionVisible}
          setVisible={setAgregarVerificacionVisible}
          setVerifications={setVerifications}
          loading={loading}
          setLoading={setLoading}
        />

        <Modal
          title={
            <Title level={4} style={{ margin: 0, color: "#1f2937" }}>
              <CopyOutlined style={{ marginRight: "8px", color: "#722ed1" }} />
              Clonar verificación
            </Title>
          }
          visible={clonarVerificacionVisible}
          onOk={() => {
            setLoading(true);
            setClonarVerificacionVisible(false);
            axios
              .post(`${process.env.REACT_APP_API_URL}/verificaciones/clone/${auth.UID}/${selectedVerification}`)
              .then((res) => {
                setLoading(false);
                message.success("Verificación clonada exitosamente");
                axios
                  .get(`${process.env.REACT_APP_API_URL}/verificaciones`, {
                    params: { u: auth.UID },
                  })
                  .then((res) => {
                    setVerifications(res.data);
                    message.success("Lista de verificaciones actualizada");
                  })
                  .catch((err) => {
                    setLoading(false);
                    console.log(err);
                    message.error("Error al actualizar lista de verificaciones");
                  });
              })
              .catch((err) => {
                setLoading(false);
                console.log(err);
                message.error("Error al clonar la verificación");
              });
          }}
          onCancel={() => {
            setClonarVerificacionVisible(false);
          }}
          okButtonProps={{
            loading: loading,
            style: {
              background: "#722ed1",
              borderColor: "#722ed1",
              borderRadius: "6px",
            },
          }}
          cancelButtonProps={{
            style: {
              borderRadius: "6px",
            },
          }}
          style={{
            borderRadius: "12px",
          }}
          bodyStyle={{
            padding: "24px",
          }}
        >
          <div style={{ textAlign: "center", padding: "16px 0" }}>
            <Title level={4} style={{ color: "#1f2937", marginBottom: "16px" }}>
              ¿Está seguro de que desea clonar la verificación?
            </Title>
            <Typography.Text style={{ color: "#6b7280", fontSize: "16px" }}>
              Esta acción crea una copia de la verificación seleccionada, incluyendo sus visitas. Puede borrarse más adelante si así lo
              desea.
            </Typography.Text>
          </div>
        </Modal>

        <Modal
          title={
            <Title level={4} style={{ margin: 0, color: "#dc2626" }}>
              <DeleteOutlined style={{ marginRight: "8px", color: "#dc2626" }} />
              Eliminar verificación
            </Title>
          }
          visible={eliminarVerificacionVisible}
          onOk={() => {
            setLoading(true);
            setEliminarVerificacionVisible(false);
            axios
              .delete(`${process.env.REACT_APP_API_URL}/verificaciones/${selectedVerification}`)
              .then((res) => {
                setLoading(false);
                message.success("Verificación eliminada");
                axios
                  .get(`${process.env.REACT_APP_API_URL}/verificaciones`, {
                    params: {
                      u: auth.UID,
                    },
                  })
                  .then((res) => {
                    setVerifications(res.data);
                    message.success("Lista de verificaciones actualizada");
                  })
                  .catch((err) => {
                    setLoading(false);
                    console.log(err);
                    message.error("Error al actualizar lista de verificaciones");
                  });
              })
              .catch((err) => {
                setLoading(false);
                console.log(err);
                message.error("Error al eliminar verificación");
              });
          }}
          onCancel={() => {
            setEliminarVerificacionVisible(false);
          }}
          okButtonProps={{
            danger: true,
            style: {
              borderRadius: "6px",
            },
          }}
          cancelButtonProps={{
            style: {
              borderRadius: "6px",
            },
          }}
          style={{
            borderRadius: "12px",
          }}
          bodyStyle={{
            padding: "24px",
          }}
        >
          <div style={{ textAlign: "center", padding: "16px 0" }}>
            <Title level={4} style={{ color: "#dc2626", marginBottom: "16px" }}>
              ¿Está seguro de que desea eliminar la verificación?
            </Title>
            <Typography.Text style={{ color: "#6b7280", fontSize: "16px" }}>
              Esta acción no se puede deshacer. Si continúa, se eliminará la verificación seleccionada.
            </Typography.Text>
          </div>
        </Modal>
      </PageWrapper>
    </div>
  );
}
